import { Component } from 'vue-property-decorator'
import Template from '@/components/BaseCurd/template'
import { StockOutTypeServiceProxy } from '@/service-proxies/app-v2/wms.service-proxies'
import { CodeRuleServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'

const sotsp = new StockOutTypeServiceProxy()
const crsp = new CodeRuleServiceProxy()

@Component
export default class DeliveryType extends Template {
  // 出库类型
  name = 'DeliveryType'
  options = {
    retrieve: sotsp.getPageStockOutType.bind(sotsp),
    search: sotsp.getStockOutType.bind(sotsp),
    create: sotsp.createStockOutType.bind(sotsp),
    update: sotsp.updateStockOutType.bind(sotsp),
    delete: sotsp.deleteStockOutType.bind(sotsp)
  }
  acl = {
    create: 'page_business_create_delivery_type',
    update: 'page_business_edit_delivery_type',
    delete: 'page_business_delete_delivery_type'
  }
  stockOutTypeList = []
  disabled = false
  // showSearch = false // 不显示搜索框

  get lang() {
    return {
      create: this.$t('page_business_create_delivery_type'),
      placeholder: this.$t('keyword'),
      search: this.$t('search'),
      delete: this.$t('page_business_delete_delivery_type')
    }
  }

  render() {
    return this.customRender()
  }

  async getData(
    current = this.filters.current,
    size = this.filters.size,
    keyWords = this.keywords,
    reload: any = false
  ) {
    if (reload) current = 1
    const fetchFn = this.options.retrieve

    const { records, total: t, size: s, current: c } = await fetchFn(
      current,
      keyWords,
      size
    )
    records.map((item, index) => item.order = index + 1)
    
    
    let dataLength = records.length;
      let copy = JSON.parse(JSON.stringify(records));
      let needPush = 0;
      if(dataLength < 30) {
        needPush = 30 - dataLength;
        for(var k=0; k<needPush; k++) {
          let obj = {  
            // id: 'none'
          }
          copy.push(obj)  
        }
      }    

      this.dataSource = JSON.parse(JSON.stringify(copy));

    this.filters = {
      total: Number(t),
      size: Number(s),
      current: Number(c)
    }
  }

   async getCodeRules(){
    const res = await crsp.list('StockOutTypeObject')
    let arr = []
    arr = res
    for( const k of arr){
        this.stockOutTypeList.push({
          label:k.name,
          value:k.id
        })
    }
  }
  created(){
    this.getCodeRules()
  }

  async handleChang(val){
    if(val) {
      this.disabled = true
      await this._form_2.form.setFieldsValue({['code']:''})
    }else {
      this.disabled = false
    }
    
  }
  get columns() {
    return [
      { title: this.$t('page_mdc_setting_index'), dataIndex: 'order', width: 150, ellipsis: true },
      { title: this.$t('page_business_delivery_type'), dataIndex: 'name', width: 250, ellipsis: true },
      { title: this.$t('page_business_delivery_type_code'), dataIndex: 'code', width: 250, ellipsis: true },
      { title: this.$t('remark'), dataIndex: 'remark', width: 350, ellipsis: true }
    ]
  }

  get schema() {
    return {
      codeRuleId: {
        label: this.$t('page_system_coding_rules'),
        type: 'select',
        display:this.showDrawer?"none":"block",
        props: {
          allowClear: true,
          placeholder: this.$t('page_system_select_coding_rule'),
          maxLength: 128,
        },
        rules: [
          {
            message: this.$t('page_system_coding_rules')
          }
        ],
        options:this.stockOutTypeList,
        on: {
          change: this.handleChang
        },
      },
      code: {
        label: this.$t('page_business_delivery_type_code'),
        type: 'input',
        props: {
          placeholder: this.$t('page_business_enter_delivery_type_code'),
          // maxLength: 48,
          disabled: this.disabled || this.showDrawer 
        },
      rules: [
          {
            required:!this.disabled,
            message: this.$t('page_business_enter_delivery_type_code')
          },
          { max: 48, message: this.$t('page_material_warehousing_custom_more48') }
        ]
      },
      name: {
        label: this.$t('page_business_delivery_type'),
        type: 'input',
        props: {
          placeholder: this.$t('page_business_enter_delivery_type'),
          // maxLength: 48
        },
        rules: [
          {
            required: true,
            message: this.$t('page_business_enter_delivery_type')
          },
          { max: 48, message: this.$t('page_material_warehousing_custom_more48') }
        ]
      },
      remark: {
        label: this.$t('remark'),
        type: 'input',
        props: {
          placeholder: this.$t('remark_tips'),
          // maxLength: 48
        },
        rules: [
          { max: 48, message: this.$t('page_material_warehousing_custom_more48') }
        ]
      }
    }
  }
  renderHeader(slot = null) {
    const { hidden } = this;

    const add = hidden.includes("create") ? null : (
      <a-button
        v-acl={this.acl.create}
        type="primary"
        style={{ marginRight: "8px" }}
        onClick={this.openCreateWindow}
      >
        {this.lang.create}
      </a-button>
    );

    const del = hidden.includes("delete") ? null : (
      <a-popconfirm
        title={this.$t("page_resource_pool_confirm_delete")}
        onConfirm={this.deleteData}
        okText={this.$t("yes")}
        cancelText={this.$t("no")}
        disabled={this.selectedIds.length < 1}
      >
        <a-button
          v-acl={this.acl.delete}
          type="danger"
          disabled={this.selectedIds.length < 1}
        >
          {this.lang.delete}
        </a-button>
      </a-popconfirm>
    );
    const printing = hidden.includes("printing") ? null : (
      <a-button
        style={{ marginLeft: "8px" }}
        disabled={this.selectedIds.length < 1}
        onClick={this.printing}
      >
        {this.$t('page_print_code')}
      </a-button>
    );
    return (
      <div
        slot="action"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>
          {add}
          {del}
          {this.ie ? this.extraHeaderAction() : null}
          {printing}
        </div>
        {this.showSearch ? ( <div style="display:flex;align-items:center">
          {slot}
          <a-input-search
            placeholder={this.lang.placeholder}
            onSearch={this.onSearch}
            enterButton={this.lang.search}
            allowClear={true}
          ></a-input-search>
        </div>) : null}
      </div>
    );
  }

}
